import React from "react";

import "../../../styles/tutorial.scss";

function Lotinha({ name }) {
  return (
    <div class="container_como_jogar">
      <div>
        <h1 className="center capitalize">{name}</h1>

        <p>
          Serão sorteados 15 números, entre 01 e 25. Apostando você poderá
          escolher de 17 a 23 dezenas e a premiação é baseada na quantidade de
          dezenas escolhidas e no valor apostado.
        </p>
      </div>
    </div>
  );
}

export default Lotinha;



// WEBPACK FOOTER //
// ./src/static/tutorial/concurso/lotinha.jsx